import script from "./TreeTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./TreeTableWidget.vue?vue&type=style&index=0&id=0b2b1830&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2b1830"]])

export default __exports__